import { render, staticRenderFns } from "./CostCategories.vue?vue&type=template&id=182fb989&"
import script from "./CostCategories.vue?vue&type=script&lang=js&"
export * from "./CostCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports